import React, { useContext, useEffect,useCallback } from "react";

import { useParams, Link } from "react-router-dom"; // Import Link for navigation
import posts from "../data/posts"; // Import posts data
import { LanguageContext } from "../LanguageContext"; // Import Language Context
import ImageButtonSection from "../components/ImageButtonSection";
import "./FullPost.css";
import FAQS from "../components/FAQS";
import { PostContext } from "../context/PostContext";
import SEO from "../components/SEO"; // Centralized SEO Component
const FullPost = () => {
  const { id } = useParams();
  const { pos } = useContext(PostContext); // Get posts from context
  const { language } = useContext(LanguageContext); // Get current language
  const handleShare = useCallback((imageUrl) => {
    if (navigator.share) {
      navigator
        .share({
          title: language === "english"
            ? "Check out this amazing image!"
            : "इस अद्भुत तस्वीर को देखें!",
          text: language === "english"
            ? "Here is an image you might like!"
            : "यहां एक तस्वीर है जो आपको पसंद आ सकती है!",
          url: imageUrl,
        })
        .then(() => console.log("Successfully shared"))
        .catch((error) => console.log("Error sharing:", error));
    } else {
      const url = encodeURIComponent(imageUrl);
      const message = encodeURIComponent(
        language === "english"
          ? "Check out this amazing image!"
          : "इस अद्भुत तस्वीर को देखें!"
      );
      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${message}`,
        "_blank"
      );
      window.open(
        `https://twitter.com/intent/tweet?url=${url}&text=${message}`,
        "_blank"
      );
      window.open(
        `https://api.whatsapp.com/send?text=${message} ${url}`,
        "_blank"
      );
    }
  }, [language]);
  // Find the current post
  const post = posts.find((p) => p.id === parseInt(id));

  // Filter out the current post to display other posts in the sidebar
  const otherPosts = pos.filter((p) => p.id !== parseInt(id));

  

  useEffect(() => {
  
  }, [id, post]);

  if (!post) {
    return <h2>{language === "english" ? "Post Not Found" : "पोस्ट नहीं मिली"}</h2>;
  }



  const metaTitle = post.title?.en ?? "No Title";
  const metaDescription = post.onedescri?.[0]?.content?.en ?? post.descriptions?.[0]?.content?.en ?? "Read this amazing post about Snapseed QR Codes!";
  const metaUrl = `https://www.snapseedqrcodes.download/collection/${post.title.en.replace(/\s+/g, "-").toLowerCase()}/${post.id}`;
  const metaImage = post.images?.[0]?.src || "https://www.snapseedqrcodes.download/default-image.jpg";

  // ✅ **Generate JSON-LD Schema Markup for Google Rich Results**
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Snapseedqrcodes",
    "headline": metaTitle,
    "description": metaDescription,
    "image": metaImage,
    "url": metaUrl,
    "author": {
      "@type": "Person",
      "name": "Rana Waseem"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Snapseed QR Codes",
      "logo": "https://www.snapseedqrcodes.download/snapseedqrcodes_logo.webp"
    },
    "datePublished": "2025-01-29",
    "dateModified": "2025-05-07"
  };

  return (
    <div className="full-post-container">
      
     {/* Use the SEO Component */}
     <SEO
        title={metaTitle}
        description={metaDescription}
        url={metaUrl}
        image={metaImage}
        schemaMarkup={schemaMarkup}
      />
      {/* Main Post Content */}
      <div className="main-post">
        {/* Hero Section */}
       {/* Descriptions with Titles */}
       {Array.isArray(post.onedescri) &&
          post.onedescri.map((desc, index) => (
            <div key={index}>
            

        <section className="hero-section">
          <h1 className="hero-title">
            {language === "english" ? desc.title?.en ?? "No Title" : desc.title?.hi ?? "कोई शीर्षक नहीं"}
          </h1>
        </section>
              <p>{language === "english" ? desc.content?.en ?? "" : desc.content?.hi ?? ""}</p>
            </div>
          ))}

     {Array.isArray(post.onedeslight) &&
          post.onedeslight.map((desc, index) => (
            <div key={index}>
        <section className="hero-section">
        <h1 className="hero-title">
            {language === "english" ? desc.title?.en ?? "No Title" : desc.title?.hi ?? "कोई शीर्षक नहीं"}
          </h1>
        </section>
              <p>{language === "english" ? desc.content?.en ?? "" : desc.content?.hi ?? ""}</p>
            </div>
       ))}


        {/* Descriptions with Titles */}
        {Array.isArray(post.descriptions) &&
          post.descriptions.map((desc, index) => (
            <div key={index}>
              <h2>{language === "english" ? desc.title?.en ?? "No Title" : desc.title?.hi ?? "कोई शीर्षक नहीं"}</h2>
              <p>{language === "english" ? desc.content?.en ?? "" : desc.content?.hi ?? ""}</p>
            </div>
          ))}


        {/* Descriptions with Titles */}
        {Array.isArray(post.desclight) &&
          post.desclight.map((desc, index) => (
            <div key={index}>
              <h2>{language === "english" ? desc.title?.en ?? "No Title" : desc.title?.hi ?? "कोई शीर्षक नहीं"}</h2>
              <p>{language === "english" ? desc.content?.en ?? "" : desc.content?.hi ?? ""}</p>
            </div>
          ))}


                 {/* Descriptions with Titles */}
        {Array.isArray(post.imagesmain) &&
          post.imagesmain.map((descl, index) => (
            <div key={index}>
              <p>{language === "english" ? descl.content?.en ?? "" : descl.content?.hi ?? ""}</p>
            </div>
          ))}
 

        {/* Bullets */}
        {Array.isArray(post.bullets) && post.bullets.length > 0 && (
          <ul>
            {post.bullets.map((bullet, index) => (
              <li key={index}>{language === "english" ? bullet?.en ?? "No Data" : bullet?.hi ?? "कोई डेटा नहीं"}</li>
            ))}
          </ul>
        )}
        {/* Additional Descriptions */}
        {Array.isArray(post.des) &&
          post.des.map((desc, index) => (
            <div key={index}>
              <h2>{language === "english" ? desc.title?.en ?? "No Title" : desc.title?.hi ?? "कोई शीर्षक नहीं"}</h2>
            </div>
          ))}
        {/* Additional Bullets */}
        {Array.isArray(post.bull) && post.bull.length > 0 && (
          <ul>
            {post.bull.map((bullet, index) => (
              <li key={index}>{language === "english" ? bullet?.en ?? "No Data" : bullet?.hi ?? "कोई डेटा नहीं"}</li>
            ))}
          </ul>
        )}
        {/* Additional Descriptions */}
        {Array.isArray(post.descrip) &&
          post.descrip.map((desc, index) => (
            <div key={index}>
              <h2>{language === "english" ? desc.title?.en ?? "No Title" : desc.title?.hi ?? "कोई शीर्षक नहीं"}</h2>
              <p>{language === "english" ? desc.content?.en ?? "No Content" : desc.content?.hi ?? "कोई सामग्री नहीं"}</p>
            </div>
          ))}

{/* Images */}
{Array.isArray(post.images) &&
  post.images.map((image, index) => {
    const title = language === "english" ? image.title?.en : image.title?.hi;
    const description = language === "english" ? image.description?.en ?? "No Description" : image.description?.hi ?? "कोई विवरण नहीं";

    // Properly format the heading text
    const heading = title ? `${index + 1}. ${title} : ${description}` : `${index + 1}. ${description}`;

    return (
      <ImageButtonSection
        key={index}
        image={image?.src ?? ""}
        id={index + 1} // Pass index separately
        heading={heading} // Pass properly formatted text
        description={description} // Keep description separate
        onShare={() => handleShare(image.src)}

      />
    );
  })}
        {/* Last Descriptions */}
        {Array.isArray(post.lastdesc) &&
          post.lastdesc.map((desc, index) => (
            <div key={index}>
              <p>{language === "english" ? desc.content?.en ?? "No Content" : desc.content?.hi ?? "कोई सामग्री नहीं"}</p>
            </div>
          ))}

        {/* FAQs */}
        {Array.isArray(post.faqs) && post.faqs.length > 0 ? (
          <FAQS faqs={post.faqs} />
        ) : (
          <p>{language === "english" ? "No FAQs available." : "कोई FAQs उपलब्ध नहीं हैं।"}</p>
        )}
      </div>

      {/* Sidebar for Other Posts */}
      <div className="sidebar">
        <h3>{language === "english" ? "Recent SnapSeed QR Posts" : "हालिया SnapSeedQR पोस्ट"}</h3>
        <ul>
  {otherPosts.map((otherPost) => (
    <li key={otherPost.id}>
      <Link
       to={`/collection/${otherPost.title.en.replace(/\s+/g, "-").toLowerCase()}/${otherPost.id}`} 
        className="sidebar-post"
      >
        {/* Display the main image for the post
        {Array.isArray(otherPost.image) && otherPost.image.length > 0 && (
          <img
            src={otherPost.image[0]?.src ?? ""}
            alt={
              language === "english"
                ? otherPost.image?.title?.en ?? "No Image"
                : otherPost.image?.title?.hi ?? "कोई छवि नहीं"
            }
            className="sidebar-image"
          />
        )} */}
        {/* Display the main image for the post */}
{otherPost.image && (
  <img
    src={otherPost.image} // Directly use the image path
    alt={language === "english" ? otherPost.title ?? "No Image" : "कोई छवि नहीं"}
    className="sidebar-image"
  />
)}
        {/* Display the post title */}
        <span className="sidebar-title">
          {language === "english"
            ? otherPost.title?.en ?? "No Title"
            : otherPost.title?.hi ?? "कोई शीर्षक नहीं"}
        </span>
      </Link>
    </li>
  ))}
</ul>

      </div>
    </div>
  );
};

export default FullPost;
